import {
  GET_GOVERNORATES,
  GET_GOVERNORATES_REQUEST_ERROR,
  GET_GOVERNORATES_REQUEST_PENDING,
  GET_GOVERNORATES_REQUEST_SUCCESS,
} from '../types/governorates'

const initialState = {
  items: [],
  pagination: {
    current: 1,
    pageSize: 20,
  },
  isGetLoading: false,
  errors: [],
}

const governorates = (state = initialState, action) => {
  switch (action.type) {
    case GET_GOVERNORATES:
      return { ...state, ...action.payload }
    case GET_GOVERNORATES_REQUEST_PENDING:
      return { ...state, isGetLoading: true }
    case GET_GOVERNORATES_REQUEST_SUCCESS:
      return { ...state, errors: [], isGetLoading: false }
    case GET_GOVERNORATES_REQUEST_ERROR:
      return { ...state, errors: action.payload, isGetLoading: false }
    default:
      return state
  }
}

export default governorates

